import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location, DecimalPipe } from '@angular/common';
import { TableHeader, CommonConstants, ColumnDef } from '../../../global/interfaces';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { Observable } from 'rxjs';
import { TransactionsData } from '../transactions.models';
import { ActivatedRoute } from '@angular/router';
import {
  selectTransactionsDetailsData,
  selectTransactionsDetailsTotal,
  selectTransactionsDetailsFund, selectTransactionsDetailsTransactions, selectTransactionsDetailsPagination, selectTransactionsLoading
} from '../transactions.selectors';
import { map, take, filter, withLatestFrom, distinctUntilChanged } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import * as moment from 'moment';
import { fromEvent, Subscription } from 'rxjs';
import {
  LoadTransactionsDetailsAction, ExportTransactionsReportAction, ExportTransactionsDetailsAction,
  SetTransactionsDetailsPaginationAction
} from '../transactions.actions';
import {
  selectCountrySelected,
  selectMainFilterSelectedAccount,
  selectMainFilterSelectedClient,
} from '../../../shared/layout/main.selectors';
//import { PaginationInfo, MosConfigurationService, MosModalComponent } from 'merceros-ui-components';
import { BehaviorSubject } from 'rxjs';

import { getDataUri } from '../../../global/getDataUri';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as pdfMake from 'pdfmake/build/pdfmake';
import { pdfFooter, pdfHeader, pdfStyle } from '../../../shared/pdfs/templates';
import { User } from '../../administration/user/user.models';
import { selectAuthUser } from '../../auth/auth.selectors';
import { selectConsultants } from '../../features.selectors';
import { LoadClientConsultantAction } from '../../features.actions';
import { CONFIG } from '../../../../config';
import { isNullOrUndefined } from 'util';
import { isEqual } from 'lodash';
import { ModalComponent } from 'atlas-modal';
import { TableColumnAlignment } from 'atlas-table';
import { Actions, DialogSizings, FieldSize } from 'atlas-cdk';
import { DropdownPlacement, DropdownTriggerType } from 'atlas-menu';
import { PaginationInfo } from 'atlas-pagination';
import { ToastService } from '../../../shared/toaster_/toaster_.service';

@Component({
  standalone: false,
  selector: 'dsp-transactions-details',
  templateUrl: 'transactions-details.component.html',
  styleUrls: ['transactions-details.component.scss']
})
export class TransactionsDetailsComponent implements OnInit, OnDestroy {
  public dropdownTriggerTypeIconButton = DropdownTriggerType.IconButton;
  public dropdownPlacementLeftStart = DropdownPlacement.LeftStart;
  @ViewChild('detail')
  public modal: ModalComponent;




  public headers: ColumnDef[] = [
    {
      name: 'Date',
      column: 'date',
      sortable: false,
      displayLabel: 'Date',
      fieldKey: 'date',

    },
    {
      name: 'Description',
      column: 'description',
      sortable: false,
      displayLabel: 'Description',
      fieldKey: 'description',


    },
    {
      name: 'Amount Currency',
      column: 'amount',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Amount Currency',
      fieldKey: 'amount',

    },
    {
      name: 'Unit Price*',
      column: 'unitPrice',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Unit Price*',
      fieldKey: 'unitPrice',


    },
    {
      name: 'Units',
      column: 'units',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Units',
      fieldKey: 'units',


    },
    {
      name: 'Unit Balance',
      column: 'unitBalance',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Unit Balance',
      fieldKey: 'unitBalance',

    }
  ];
  public headersNZ: ColumnDef[] = [
    {
      name: 'Date',
      column: 'date',
      sortable: false,
      displayLabel: 'Date',
      fieldKey: 'date',

    },
    {
      name: 'Description',
      column: 'description',
      sortable: false,
      displayLabel: 'Description',
      fieldKey: 'description',

    },
    {
      name: 'Gross Contributions / Withdrawals',
      column: 'grossContributionsWithdrawals',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Gross Contributions / Withdrawals',
      fieldKey: 'grossContributionsWithdrawals',
    },
    {
      name: 'PIE Tax Paid/Rebated',
      column: 'pieTaxPaid',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'PIE Tax Paid/Rebated',
      fieldKey: 'pieTaxPaid',

    },
    {
      name: 'Net Contributions / Withdrawals',
      column: 'netContributionsWithdrawals',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Net Contributions / Withdrawals',
      fieldKey: 'netContributionsWithdrawals',

    },
    {
      name: 'Unit Price*',
      column: 'unitPrice',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Unit Price*',
      fieldKey: 'unitPrice',

    },
    {
      name: 'Units',
      column: 'units',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Units',
      fieldKey: 'units',

    },
    {
      name: 'Unit Balance',
      column: 'unitBalance',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Unit Balance',
      fieldKey: 'unitBalance',

    }
  ];

  public pagination$: Observable<PaginationInfo>;
  public displayData$: Observable<TransactionsData>;
  public firstPage$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public lastPage$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public fundName$: Observable<string>;
  public loading$: Observable<boolean>;
  public showPaginationNumbers$: Observable<boolean>;
  public transactionsLength$: Observable<number>;
  public fromDate = ``;
  public toDate = ``;
  public country = '';
  private readonly subscription: Subscription = new Subscription();
  public modalSize: DialogSizings = DialogSizings.xlarge
  public showExportMenu = false;
  sizeMedium = FieldSize.medium;

  public constructor(
    private readonly store: Store<AppState>,
    private readonly route: ActivatedRoute,
    private readonly location: Location,
    //public config: MosConfigurationService,
    private readonly decimalPipe: DecimalPipe,
    private readonly _toasterService: ToastService
  ) {
    this.pagination$ = this.selectPagination();
    this.fundName$ = this.selectFundName();
    this.displayData$ = this.selectDisplayData();
    this.transactionsLength$ = this.selectTransactionsLength();
    this.showPaginationNumbers$ = this.selectShowPaginationNumbers();

  }

  public ngOnInit(): void {
    this.subscription.add(this.subscribeSelectedCountry());
    this.subscription.add(
      fromEvent(document, 'click').subscribe(() => {
        this.showExportMenu = false;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  public subscribeSelectedCountry(): Subscription {
    return this.store.pipe(
      select(selectCountrySelected)
    ).subscribe(country => {
      this.country = country;
    });
  }


  // public open(data): void {
  //   this.fromDate = data.from;
  //   this.toDate = data.to;
  //   this.modal.launch();

  //   this.subscription.add(this.subscribeTransactionsDetails(data));
  //   this.onPaginate({ page: 1, itemsByPage: 10, total: 0 });
  //   this.loading$ = this.selectLoading();
  // }

  public open(data): void {
    this.fromDate = data.from;
    this.toDate = data.to;
    this.modal.launch();
    this.normalizeModalHeaderLayout();

    this.subscription.add(this.subscribeTransactionsDetails(data));
    this.loading$ = this.selectLoading();

    // Wait for total count to be > 0 before initializing pagination
    this.store.pipe(
      select(selectTransactionsDetailsTotal),
      filter(total => total > 0),
      take(1)
    ).subscribe(total => {
      this.onPaginate({ page: 1, itemsByPage: 10, total });
    });
  }

  private normalizeModalHeaderLayout(): void {
    const stripModalTitleClasses = () => {
      const header = document.querySelector('.trans-details-modal-header') as HTMLElement;
      if (!header) {
        return;
      }

      header.classList.remove('modal-title-left', 'modal-title');

      let parent = header.parentElement;
      while (parent) {
        parent.classList.remove('modal-title-left', 'modal-title');
        parent = parent.parentElement;
      }
    };

    stripModalTitleClasses();
    setTimeout(stripModalTitleClasses, 0);
    setTimeout(stripModalTitleClasses, 50);
    setTimeout(stripModalTitleClasses, 150);
  }

  private selectLoading(): Observable<boolean> {
    return this.store.pipe(
      select(selectTransactionsLoading),
    );
  }
  private selectShowPaginationNumbers(): Observable<boolean> {
    return this.store.pipe(
      select(selectTransactionsDetailsTotal),
      filter(total => total > 0),
      map(total => total > 10)
    );
  }
  private selectPagination(): Observable<PaginationInfo> {
    // return combineLatest(
    //   this.store.pipe(select(selectTransactionsDetailsTotal)),
    //   this.store.pipe(select(selectTransactionsDetailsPagination)),
    // ).pipe(
    return combineLatest([
      this.store.pipe(select(selectTransactionsDetailsTotal)),
      this.store.pipe(select(selectTransactionsDetailsPagination))]
    ).pipe(
      map(([total, pagination]) => ({ total, ...pagination }))
    );
  }

  public onPaginate(event: PaginationInfo): void {
    this.showExportMenu = false;
    this.store.dispatch(new SetTransactionsDetailsPaginationAction(event));
  }


  public toggleExportMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.showExportMenu = !this.showExportMenu;
  }

  public closeExportMenu(): void {
    this.showExportMenu = false;
  }

  // private selectDisplayData(): Observable<TransactionsData[]> {
  //   // return combineLatest(
  //   //   this.store.pipe(select(selectTransactionsDetailsData)),
  //   //   this.pagination$
  //   // ).pipe(
  //   return combineLatest([
  //     this.store.pipe(select(selectTransactionsDetailsData)),
  //     this.pagination$]
  //   ).pipe(
  //     map(([data, pagination]) => {
  //       if (!isNullOrUndefined(data)) {

  //         if (data.transactions.length &&
  //           (
  //             (data.transactions[0].date === undefined && data.transactions[0].description === 'Opening Balance') ||
  //             (data.transactions[data.transactions.length - 1].date === undefined &&
  //               data.transactions[data.transactions.length - 1].description === 'Closing Balance')
  //           )
  //         ) {
  //           return data;
  //         }
  //         if (!isNullOrUndefined(pagination)) {
  //           const offset = (pagination.page - 1) * pagination.itemsByPage;
  //           const firstPage = pagination.page === 1;
  //           const lastPage = (pagination.total - offset) <= pagination.itemsByPage;
  //           if (firstPage) {
  //             this.firstPage$.next(true);
  //             this.lastPage$.next(false);

  //             data.transactions.unshift({
  //               date: undefined,
  //               description: 'Opening Balance',
  //               amount: data.fund.opening.value,
  //               unitPrice: data.fund.opening.price,
  //               units: undefined,
  //               unitBalance: data.fund.opening.units
  //             });
  //           }

  //           if (lastPage) {
  //             this.lastPage$.next(true);
  //             this.firstPage$.next(false);

  //             data.transactions.push({
  //               date: undefined,
  //               description: 'Closing Balance',
  //               amount: data.fund.closing.value,
  //               unitPrice: data.fund.closing.price,
  //               units: undefined,
  //               unitBalance: data.fund.closing.units
  //             });
  //           }

  //           if (!firstPage && !lastPage) {
  //             this.firstPage$.next(false);
  //             this.lastPage$.next(false);
  //           }
  //         }

  //         return data;
  //       }
  //     }),
  //     map(data => [data])
  //   );
  // }


  private selectDisplayData(): Observable<TransactionsData> {
    return combineLatest([
      this.store.pipe(select(selectTransactionsDetailsData)),
      this.pagination$
    ]).pipe(
      map(([data, pagination]) => {
        if (!data) {
          return null;
        }


        const displayData: TransactionsData = JSON.parse(JSON.stringify(data));

        const transactions = displayData.transactions || [];

        const pagedTransactions = transactions

        const firstPage = pagination.page === 1;

        if (firstPage) {
          this.firstPage$.next(true);
          this.lastPage$.next(false);
          pagedTransactions.unshift({
            date: undefined,
            description: 'Opening Balance',
            amount: displayData.fund.opening.value,
            unitPrice: displayData.fund.opening.price,
            units: undefined,
            unitBalance: displayData.fund.opening.units
          });
        }


        const totalPages = Math.ceil(pagination.total / pagination.itemsByPage);
        if (pagination.page === totalPages) {
          this.lastPage$.next(true);
          this.firstPage$.next(false);
          pagedTransactions.push({
            date: undefined,
            description: 'Closing Balance',
            amount: displayData.fund.closing.value,
            unitPrice: displayData.fund.closing.price,
            units: undefined,
            unitBalance: displayData.fund.closing.units
          });
        }

        displayData.transactions = pagedTransactions;

        if (!firstPage && (pagination.page !== totalPages)) {
          this.firstPage$.next(false);
          this.lastPage$.next(false);
        }
        return displayData;
      })
    );
  }

  public formatDate(date: string | Date, format = 'YYYY-MM-DD'): string {
    let parsedDate: Date;
    if (date instanceof Date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      parsedDate = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
    } else {
      parsedDate = new Date(date);
    }

    const year = parsedDate.getUTCFullYear();
    const month = ('0' + (parsedDate.getUTCMonth() + 1)).slice(-2);
    const day = ('0' + parsedDate.getUTCDate()).slice(-2);
    const result = `${year}-${month}-${day}`;
    return result;
  }
  public transformDate(date: string, format = 'YYYY-MM-DD'): string {
    return moment(date).format(format);
  }
  public formatId(fund: number, transaction: number, field: string): string {
    return `fund-${fund}-transaction-${transaction}-${field}`;
  }
  public onExportPDFServerModal(): void {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.store.pipe(select(selectMainFilterSelectedClient)),
    //   this.displayData$
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.displayData$]
    ).pipe(
      filter(([account, client, data]) => !!account && !!data),
      take(1)
    ).subscribe(([account, client, data]) => {

      this.store.dispatch(new ExportTransactionsDetailsAction({
        account: account._id,
        clientId: client._id,
        clientName: client.name,
        fundId: data.fund._id,
        funds: null,
        from: this.fromDate ? this.formatDate(this.fromDate) : undefined,
        to: this.toDate ? this.formatDate(this.toDate) : undefined,
        userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
        country: this.country
      }));
    });
  }
  public onExportCSVModal(): void {
    // combineLatest(
    //   this.store.pipe(select(selectMainFilterSelectedAccount)),
    //   this.displayData$
    // ).pipe(
    combineLatest([
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.displayData$]
    ).pipe(
      filter(([account, data]) => !!account && !!data),
      map(([account, data]) => (
        {
          download: data.transactions.length > 0,
          account: account._id || '',
          funds: data.fund._id,
          from: this.fromDate ? this.formatDate(this.fromDate) : undefined,
          to: this.toDate ? this.formatDate(this.toDate) : undefined,
          userDate: moment().format('DD/MM/YYYY h:mm:ss a ') + Intl.DateTimeFormat().resolvedOptions().timeZone,
          country: this.country
        }
      )),
      take(1)
    ).subscribe(payload => {
      if (payload.download) {
        this.store.dispatch(new ExportTransactionsReportAction(payload));
      } else {
        //this.store.dispatch(new AddErrorToastAction(`There is no data to export in specified fund and date.`));
        return this._toasterService.launchAlertError(`There is no data to export in specified fund and date.`, Actions.error);
      }
    });
  }
  private selectTransactionsLength(): Observable<number> {
    return this.displayData$.pipe(
      filter(data => !!data && !!data.transactions),
      map(data => data.transactions.length)
    );
  }
  private selectFundName(): Observable<string> {
    return this.store.pipe(
      select(selectTransactionsDetailsFund),
      filter(fund => !!fund),
      map(fund => fund.name)
    );
  }
  private subscribeTransactionsDetails(data): Subscription {

    // return combineLatest(
    //   this.store.pipe(select(selectTransactionsDetailsPagination)),
    // ).pipe(
    // return combineLatest([
    //   this.store.pipe(select(selectTransactionsDetailsPagination))]
    // ).pipe(
    //   map(([pagination]) => ({
    //     pagination
    //   })),
    //   distinctUntilChanged(isEqual)
    // ).subscribe(pagination => {

    //   const payload = {
    //     account: data.accountId,
    //     params: {
    //       filter: {
    //         fundId: data.fund,
    //         from: this.formatDate(data.from),
    //         to: this.formatDate(data.to)
    //       },
    //       pagination: {
    //         page: pagination.page,
    //         itemsByPage: pagination.itemsByPage,
    //         total: pagination.total
    //       },
    //       sort: {
    //         column: 'date',
    //         reverse: false
    //       },
    //       country: this.country
    //     }
    //   };
    //   this.store.dispatch(new LoadTransactionsDetailsAction(payload));
    // });
    return combineLatest([
      this.store.pipe(select(selectTransactionsDetailsPagination))
    ]).pipe(
      map(([pagination]) => pagination),
      distinctUntilChanged(isEqual)
    ).subscribe(pagination => {
      const payload = {
        account: data.accountId,
        params: {
          filter: {
            fundId: data.fund,
            from: this.formatDate(data.from),
            to: this.formatDate(data.to)
          },
          pagination: {
            page: pagination.page,
            itemsByPage: pagination.itemsByPage,
            total: pagination.total
          },
          sort: {
            column: 'date',
            reverse: false
          },
          country: this.country
        }
      };
      this.store.dispatch(new LoadTransactionsDetailsAction(payload));
    });
  }

  public onBackModal(): void {
    this.showExportMenu = false;
    this.modal.closeModal();
  }
  getMin(a: number, b: number): number {
    return Math.min(a, b);
  }
}
